import Navigation from 'components/Navigation';
import React from 'react';
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from 'react-router-dom';

import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import ExportDataPage from './ExportDataPage';
import ProjectPermissionsGuard from '../../components/Permissions/ProjectPermissionsGuard';

interface ExportProjectPageProps
  extends RouteComponentProps,
    WithAppStoreProps {
  match: any;
}

const ExportProjectPage = (props: ExportProjectPageProps) => {
  const { match, appState } = props;
  const { selectedProject } = appState;
  return (
    <>
      <Navigation>
        <Switch>
          <Route
            path={`${match.url}`}
            render={() => {
              return (
                <ProjectPermissionsGuard
                  permissions={['viewUsers']}
                  redirectTo={`/project/${selectedProject}/dashboard`}
                >
                  <ExportDataPage />
                </ProjectPermissionsGuard>
              );
            }}
          />
        </Switch>
      </Navigation>
    </>
  );
};

export default withRouter(withAppStore(ExportProjectPage));
